/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step3_Embed_On_Sync_LabelInputs */



/**
* | output |
* | --- |
* | "Auto-embed on sync" |
*
* @param {Spaces_Wizard_Step3_Embed_On_Sync_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step3_embed_on_sync_label = /** @type {((inputs?: Spaces_Wizard_Step3_Embed_On_Sync_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step3_Embed_On_Sync_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisch beim Sync embedden")
	return /** @type {LocalizedString} */ ("Auto-embed on sync")
});